import { render, staticRenderFns } from "./projectWideRepoInfoList.vue?vue&type=template&id=e2da8fd8&"
import script from "./projectWideRepoInfoList.vue?vue&type=script&lang=js&"
export * from "./projectWideRepoInfoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports